import React from "react";
import {Form} from "antd";
import IWidgetProps from "../../../../../model/interface/widget/IWidgetProps";
import IFormElementFunctions from "../../../../../model/interface/form/IFormElementFunctions";
import IEntityTableOptions from "../../../../../model/interface/form/elementOptions/IEntityTableOptions";
import FormElementEntityTable from "./FormElementEntityTable";
import IField from "../../../../../model/interface/dataStorage/IField";
import {connect} from "react-redux";
import selectors from "../../../../../redux/selectors";
import LocaleText from "../../../settings/dictionary/LocaleText";
import {IAppState} from "../../../../../redux/store";


interface IProps extends IWidgetProps<IFormElementFunctions, IEntityTableOptions> {
    getText: (code: string, fallBack?: string) => string
}

class FormElementEntityTableWrapper extends React.Component<IProps> {

    render() {
        const {id, functions, options} = this.props
        const field = functions.getNode(id).field as IField

        return (
            <div>
                {field && (
                    <Form.Item label={<LocaleText code={field.label || ''}/>} required={options.required}>
                        <FormElementEntityTable {...this.props} className={field.targetEntity!} />
                    </Form.Item>
                ) }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(FormElementEntityTableWrapper)